<template>
  <div class="contentDiv">
    <div class="cover scrollable-div">
      <HeaderContainer :active-index="currentMenuIndex" @menu-select="onMenuSelect"/>


      <el-row  :gutter="20" style="margin-left: 0px; margin-right: 0px;width: 1170px">
        <!-- 大屏幕: 左侧30%/右侧70% -->
        <!-- 小屏幕: 堆叠显示 -->
        <el-col :xs="24" :sm="24" :md="8" :lg="7" :xl="7" style="padding: 0px">
          <div class="responsive-left">
            <!-- 左侧内容 -->
            <div class="widgets row5 coll">
              <div class="mybox hbox" id="help_box">
                <div class="mybox_title subcolumns">
                  <div>
                    <div class="title">彩種介紹 / {{title}}</div>
                  </div>
                </div>
                <div class="mybox_content">
                  <ul>
                    <li class="top"><a @click="showFun(1,'銀河娛樂彩簡介')">銀河娛樂彩簡介</a></li>
                  </ul>
                  <!--ul><li class="top"><a href="/czjs2.html">開獎時間</a></li></ul-->
                  <ul>
                    <li class="top"><a @click="showFun(2,'獲獎資格')">獲獎資格</a></li>
                  </ul>
                  <ul>
                    <li class="top"><a @click="showFun(3,'獎金分配')">獎金分配</a></li>
                  </ul>
                  <ul>
                    <li class="top"><a @click="showFun(4,'基本玩法')">基本玩法</a></li>
                  </ul>

                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="16" :lg="17" :xl="17" style="padding: 0px">
          <div class="responsive-right">
            <!-- 右侧内容 -->
            <!-- 彩種介紹 / 銀河娛樂彩簡介 -->
            <div v-if="dialogVisible==1" class="widgets row6 colr rowr columnar" id="help_index">
              <div class="mybox dbox" id="">
                <div class="mybox_title subcolumns">
                  <div>
                    <div class="title">彩種介紹 / 銀河娛樂彩簡介</div>
                  </div>
                </div>
              </div>
              <div class="content" style="background:#FFF; color:#000;border-bottom:none;">
                <table border="0" cellpadding="0" cellspacing="0"
                       style="margin: 0px; padding: 0px; font-size: 12.0132px; ">
                  <tbody style="margin: 0px; padding: 0px; font-size: 12.0144px;">
                  <tr style="margin: 0px; padding: 0px; font-size: 12.0156px;">
                    <td style="margin: 0px; padding: 0.5em; font-size: 12.0168px; text-align: left;">
				<span style="font-size:16px;">澳門銀河娛樂彩是從1至49個號碼中選出六個為中獎號碼的獎券，由澳門銀河娛樂有限公司「澳門銀河娛樂有限公司」經辦 。<br
            style="margin: 0px; padding: 0px; font-size: 12.018px;">
				<br style="margin: 0px; padding: 0px; font-size: 12.018px;">
				<span style="margin: 0px; padding: 0px;">銀河娛樂</span>彩每星期攪珠三次，通常於星期一、星期三及非賽馬日之星期五或日晚上舉行，<br
              style="margin: 0px; padding: 0px; font-size: 12.018px;">
				並由電視台現場直播。</span></td>
                    <td style="margin: 0px; padding: 0.5em; font-size: 12.0168px;">
                      <span style="font-size:14px;"><img class="cz_dlt_img" src="@/assets/1-1F3201UH5153.png"
                                                         style="margin: 0px 6px; padding: 0px; border: 0px; font-size: 12.018px; width: 222px; height: 193px;"></span>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <br>
                <br>
                <table class="cz_zhengshu_table" border="0" cellpadding="1" cellspacing="1" style="width: 500px">
                  <tbody>
                  <tr>
                    <td>
                      <img class="cz_shuijin_img" alt="" src="@/assets/1-1F33015515BJ.gif" style="width: 201px; height: 249px;"></td>
                    <td>
                      <img class="cz_zhengshu_img" alt="" src="@/assets/1-1F401013Q51D.gif" style="width: 480px; height: 349px;"></td>
                  </tr>
                  </tbody>
                </table>
                <br></div>
            </div>

            <!-- 获奖资格-->
            <div v-if="dialogVisible==2" class="widgets row6 colr rowr columnar" id="help_index">
              <div class="mybox dbox" id="">
                <div class="mybox_title subcolumns">
                  <div>
                    <div class="title">彩種介紹 / 獲獎資格</div>
                  </div>
                </div>
              </div>
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="text-align: left;padding: 10px;color: #000">
                <tbody>
                <tr>
                  <td>
                    澳門銀河娛樂注項單位為每注港幣10元。選擇複式或膽拖注項時，可以每注港幣$5「部份注項單位」投注。有關之獎金則根據每注「部份注項單位」佔注項單位的份數計算。<br>
                    <br>
                    每期 澳門銀河娛樂攪珠均從49個號碼中攪出七個號碼。首六個號碼稱為「攪出號碼」，而第七個號碼稱為「特別號碼」。&nbsp;<br>
                    獎項詳情如下：</td>
                </tr>
                <tr>
                  <td>
                    <table class="mainTable" border="1" cellpadding="0" cellspacing="0"  style="text-align: left" width="100%">
                      <tbody>
                      <tr>
                        <td align="center" nowrap="nowrap" valign="top" width="8%">
                          頭獎</td>
                        <td valign="top" width="34%">
                          選中6個「攪出號碼」</td>
                        <td valign="top">
                          獎金會因應該期獲中頭獎注數而有所不同，每期頭獎獎金基金<br>
                          訂為不少於港幣800萬元。</td>
                      </tr>
                      <tr>
                        <td align="center" valign="top">
                          二獎</td>
                        <td valign="top">
                          選中5個「攪出號碼」+「特別號碼」</td>
                        <td valign="top">
                          獎金會因應該期獲中二獎注數而有所不同</td>
                      </tr>
                      <tr>
                        <td align="center" valign="top">
                          三獎</td>
                        <td valign="top">
                          選中5個「攪出號碼」</td>
                        <td valign="top">
                          獎金會因應該期獲中三獎注數而有所不同</td>
                      </tr>
                      <tr>
                        <td align="center" valign="top">
                          四獎</td>
                        <td valign="top">
                          選中4個「攪出號碼」+「特別號碼」</td>
                        <td valign="top">
                          固定獎金港幣9,600元</td>
                      </tr>
                      <tr>
                        <td align="center" valign="top">
                          五獎</td>
                        <td valign="top">
                          選中4個「攪出號碼」</td>
                        <td valign="top">
                          固定獎金港幣640元</td>
                      </tr>
                      <tr>
                        <td align="center" valign="top">
                          六獎</td>
                        <td valign="top">
                          選中3個「攪出號碼」+「特別號碼」</td>
                        <td valign="top">
                          固定獎金港幣320元</td>
                      </tr>
                      <tr>
                        <td align="center" valign="top">
                          七獎</td>
                        <td valign="top">
                          選中3個「攪出號碼」</td>
                        <td valign="top">
                          固定獎金港幣40元</td>
                      </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td>
                    中獎登記</td>
                </tr>
                <tr>
                  <td>
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tbody>
                      <tr>
                        <td>
                          <p>
                            若獲中之獎金為每十元一注超過五百萬元，所有中獎彩票持票人士或經由電話投注服務的中獎人士，包括使用智財咭、0085267488783電話投注自動服務系統等，請於指定時間(公佈攪珠結果後至翌日下午5時)致電本會0085267488783登記。(使用互動投注服務途徑除外)</p>
                          <p>
                            互動投注服務包括網上投注服務「投注區」、流動投注服務、Racing Touch流動應用程式及電訊運財寶。</p>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                <tr>
                  <td>
                    領取獎金</td>
                </tr>
                <tr>
                  <td>
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tbody>
                      <tr>
                        <td>
                          <p>
                            所有獲中彩票，必須於有關攪珠的日期後起計60天內領取 (例子：於3月1日所舉行的攪珠的獲中彩票，可於3月1日當天至4月30日內任何一天領取)。</p>
                          <br>
                          所有交易俱按照澳門馬會獎券有限公司不時修訂之獎券規例，以及澳門賽馬會不時修訂之博彩設施規例辦理。<br>
                          此規例之副本可於發售獎券之所有地點及澳門賽馬會總部大樓索閱。如有任何查詢，請致電1817熱線或與場外<br>
                          投注處之顧客諮詢服務員聯絡。</td>
                      </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <!-- 彩種介紹 / 獎金分配-->
            <div v-if="dialogVisible==3" class="widgets row6 colr rowr columnar" id="help_index">
              <div class="mybox dbox" id="">
                <div class="mybox_title subcolumns">
                  <div>
                    <div class="title">彩種介紹 / 獎金分配</div>
                  </div>
                </div>
              </div>
              <div class="content" style="background:#FFF; color:#000;border-bottom:none;text-align: left;">
                <table border="0" cellpadding="0" cellspacing="0" style="width: 100%; text-align: left;">
                  <tbody>
                  <tr>
                    <td width="689">
                      <table border="0" cellpadding="0" cellspacing="0" width="100%">
                        <tbody>
                        <tr>
                          <td nowrap="nowrap">
                            &nbsp;</td>
                        </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table border="0" cellpadding="0" cellspacing="0" width="100%">
                        <tbody>
                        <tr>
                          <td >
                            <img class="cz_chat_img" src="@/assets/1-1F320201TB50.gif" style="width: 361px; height: 174px;"></td>
                          <td valign="top" >
                            每期頭獎獎金基金訂為不少於港幣800萬元，並不設上限。<br>
                            <br>
                            若頭獎及/或二獎無人中獎，獎金將會撥入下一期攪珠的頭獎基金作「多寶」金額。</td>
                        </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table border="0" cellpadding="0" cellspacing="0" id="mainTable" width="100%">
                        <tbody>
                        <tr>
                          <td align="center" nowrap="nowrap" valign="top" width="20%">
                            各組獎金</td>
                          <td valign="top">
                            獎金分配</td>
                        </tr>
                        <tr>
                          <td align="center" nowrap="nowrap" valign="top">
                            第一組獎金</td>
                          <td valign="top">
                            45% x ﹝獎金基金減去第四、五、六及七組的總獎金及金多寶扣數*﹞÷ 中獎單位</td>
                        </tr>
                        <tr>
                          <td align="center" valign="top">
                            第二組獎金</td>
                          <td valign="top">
                            15% x ﹝獎金基金減去第四、五、六及七組的總獎金及金多寶扣數*﹞÷ 中獎單位</td>
                        </tr>
                        <tr>
                          <td align="center" valign="top">
                            第三組獎金</td>
                          <td valign="top">
                            40% x ﹝獎金基金減去第四、五、六及七組的總獎金及金多寶扣數*﹞÷ 中獎單位</td>
                        </tr>
                        <tr>
                          <td align="center" valign="top">
                            第四組獎金</td>
                          <td valign="top">
                            每注港幣9,600元</td>
                        </tr>
                        <tr>
                          <td align="center" valign="top">
                            第五組獎金</td>
                          <td valign="top">
                            每注港幣640元</td>
                        </tr>
                        <tr>
                          <td align="center" valign="top">
                            第六組獎金</td>
                          <td valign="top">
                            每注港幣320元</td>
                        </tr>
                        <tr>
                          <td align="center" valign="top">
                            第七組獎金</td>
                          <td valign="top">
                            每注港幣40元</td>
                        </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td valign="top">
                      *&nbsp;由二零零六年七月一日起，金多寶扣數定為獎金基金減去第四、五、六及七組總獎金後的百分之九。</td>
                  </tr>
                  </tbody>
                </table>
                <img class="bbbb" alt="" src="@/assets/1-1F4010105592C.gif"  style=" height: 99px;">				</div>
            </div> <!-- 彩種介紹 / 基本玩法-->

            <div v-if="dialogVisible==4" class="widgets row6 colr rowr columnar" id="help_index">
              <div class="mybox dbox" id="">
                <div class="mybox_title subcolumns">
                  <div>
                    <div class="title">彩種介紹 / 基本玩法</div>
                  </div>
                </div>
              </div>
              <div class="content" style="background:#FFF; color:#000;border-bottom:none;text-align: left;">
                <table border="0" cellpadding="1" cellspacing="1" >
                  <tbody>
                  <tr>
                    <td>
                      銀河娛樂是一種樂透型遊戲。您必須從01~49中任選6個號碼進行投注。開獎時，開獎單位將隨機開出六個號碼加一個特別號，這一組號碼就是該期銀河娛樂的中獎號碼，也稱為「獎號」。您的六個選號中，如果有三個以上（含三個號碼）對中當期開出之六個號碼（特別號只適用於貳獎、肆獎、陸獎和柒獎），即為中獎，並可依規定兌領獎金。<br>
                      <br>
                      各獎項的中獎方式如下表：<br>
                      <table border="0" cellpadding="0" cellspacing="1"  >
                        <tbody class="cz_hongdian_img">
                        <tr>
                          <td >
                            中獎方式</td>
                          <td >
                            中獎方式圖示</td>
                          <td >
                            獎項</td>
                        </tr>
                        <tr>
                          <td>
                            與當期六個獎號完全相同者</td>
                          <td>
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;"></td>
                          <td>
                            頭獎</td>
                        </tr>
                        <tr>
                          <td>
                            對中當期獎號之任五碼＋特別號</td>
                          <td>
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5204O38.jpg"  style="width: 21px; height: 21px;"></td>
                          <td>
                            貳獎</td>
                        </tr>
                        <tr>
                          <td>
                            對中當期獎號之任五碼</td>
                          <td>
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;"></td>
                          <td>
                            參獎</td>
                        </tr>
                        <tr>
                          <td>
                            對中當期獎號之任四碼＋特別號</td>
                          <td>
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5204O38.jpg"  style="width: 21px; height: 21px;"></td>
                          <td>
                            肆獎</td>
                        </tr>
                        <tr>
                          <td>
                            對中當期獎號之任四碼</td>
                          <td>
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;"></td>
                          <td>
                            伍獎</td>
                        </tr>
                        <tr>
                          <td>
                            對中當期獎號之任三碼＋特別號</td>
                          <td>
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5204O38.jpg"  style="width: 21px; height: 21px;"></td>
                          <td>
                            陸獎</td>
                        </tr>
                        <tr>
                          <td>
                            對中當期獎號之任三碼</td>
                          <td>
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;">&nbsp;
                            <img src="@/assets/1-1F31G5115L29.jpg"  style="width: 21px; height: 21px;"></td>
                          <td>
                            <span style="font-family: Arial, Helvetica, sans-serif, 新宋体;">柒獎</span></td>
                        </tr>
                        <tr>
                          <td>
                            &nbsp;</td>
                          <td>
                            &nbsp;</td>
                          <td>
                            <br>
                            &nbsp;</td>
                        </tr>
                        </tbody>
                      </table>
                    </td>
                    <td>
                      <img class="cz_zjt_img" src="@/assets/1-1F31G519194A.jpg"  style="width: 239px; height: 585px;">
                    </td>
                  </tr>
                  </tbody>
                </table>
                <img alt="" src="@/assets/1-1F4010105592C.gif"  class="bbbb" style=" height: 99px;">				</div>
            </div>
          </div>
        </el-col>
      </el-row>


      <footer>
        <div class="foot_con pub_case pure">
          <div class="link_foo">
            <a href="" target="_blank">聯繫我們</a> |
            <a href="" target="_blank">反饋意見</a> |
            <a href="" target="_blank">私密條款</a> |
            <a href="" target="_blank">私密條款</a> |
            <a href="" target="_blank">免責聲明</a> |
            <a href="" target="_blank">網頁指南</a> |
          </div>
          <div class="copyRight at_on">
            @2011 澳門銀河娛樂有限公司版權所有 不得轉載
          </div>
        </div>
      </footer>
    </div>
  </div>

</template>

<script>

import HeaderContainer from "@/components/HeaderContainer.vue";

export default {
  name: 'CzIntroduce',
  components: {HeaderContainer},
  data() {
    return {
      currentMenuIndex: '2', // 根据当前路由设置: 1,
      dialogVisible:1,
      title:"銀河娛樂彩簡介"
    }
  },
  created() {

  },
  methods: {
    /*主键函数*/
    onMenuSelect(index, indexPath) {
      console.log('选中菜单:', index, indexPath)
    },
    showFun(type,title){
      this.dialogVisible=type
      this.title=title
    },
    hrefUrl(url) {
      window.location.href = url;
    },
    routerUrl(url) {
      this.$router.replace(url);
    },


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cover {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 200;
  padding: 0;
  overflow-y: auto;
  justify-items: center;
}


.contentDiv {
  padding: 0;
  background: rgb(4, 23, 65);
  /*background-image: url("../assets/bgvideo.webp");*/
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  width: 100%;
  height: 100%;
  /*display: flex;*/
  align-items: center; /*定义父元素的元素垂直居中*/
  justify-content: center; /*定义子元素的里的元素水平居中*/
  text-align: center;
}

.horizontal-nav li {
//margin: 0 15px; //padding: 8px 16px; color: white;
  border-radius: 4px;
}


.responsive-left, .responsive-right {
  background: #f5f7fa;
  border-radius: 4px;
  margin-bottom: 20px;
}


.responsive-left {
  text-align: left;
}
/**
.responsive-right {
  margin-left: 10px;
} */

/**
  左侧
 */
.mybox {
  border: 1px solid rgb(43, 61, 97);
  background: rgb(30, 44, 81);
  padding: 0px;
  margin: 0px;
}

.mybox .mybox_title {
  background-color: #2b3e68;
  height: 32px;
  border-bottom: 0px solid rgb(43, 61, 97);
}

.mybox .mybox_title div .title {
  font-size: 14px;
  font-weight: bold;
  color: rgb(254, 208, 1);
  padding: 8px;
}

.mybox .mybox_content {
  color: rgb(201, 226, 238);
}

ul {
  list-style-type: none;
  border-bottom: 1px solid rgb(43, 61, 97);
}

ul, ol, dl {
  line-height: 1.5em;
  margin: 0px;
  padding: 0px;
}

#help_box .mybox_content li.top {
  padding-left: 20px;
}

.mybox_content li a:hover {
  color: rgb(254, 208, 1);
  cursor: pointer;
}

#help_box .top {
  font-weight: bold;
  background: rgb(29, 44, 81);
  border-bottom: 1px solid rgb(43, 61, 97);
  font-size: 14px;
  line-height: 25px;
}

#help_box .mybox_content li.top a {
  display: block;
}

.mybox .mybox_content a {
  color: rgb(255, 255, 255);
}

/**
右侧
 */

/**
简介
 */
.dbox {
  background: rgb(255, 255, 255);
}

.mybox {
  border: 1px solid rgb(43, 61, 97);
  background: rgb(30, 44, 81);
  padding: 0px;
  margin: 0px;
}

.mybox .mybox_title {
  background: rgb(29, 44, 81);
  height: 32px;
  border-bottom: 0px solid rgb(43, 61, 97);
}

.subcolumns {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.mybox .mybox_title div .title {
  font-size: 14px;
  font-weight: bold;
  color: rgb(254, 208, 1);
  padding: 8px;
  text-align: left;
}

/**
获奖资格
 */
.content {
  border: 1px solid rgb(43, 61, 97);
  background: rgb(30, 44, 81);
  padding: 6px;
  margin: 0px;
}
.mainTable {
  text-align: left;
}
.mainTable tr td{
  padding: 0.5em;
}
.content {
  border: 1px solid rgb(43, 61, 97);
  background: rgb(30, 44, 81);
  padding: 6px;
  margin: 0px;
}

/**
页脚
 */
footer .foot_con {
  padding: 15px 0;
  color: #4e6692;
  font-size: 12px;
}

.pub_case {
  margin-left: auto;
  margin-right: auto;
}

footer .link_foo {
  float: right;
}

footer .copyRight {
  float: left;
}

footer .foot_con a {
  color: #4e6692;
}
@media (max-width:500px) {

  .link_foo{
    font-size: 4px;
  }

  .copyRight{
    font-size: 4px;
  }

  .bbbb{
    width: 20rem;
  }
  .logo111{
    position: absolute;
    margin-top: 14px !important;
    width: 100px;
  }



  .cz_dlt_img{
    width: 120px !important;
    height: 101px !important;

  }


  .cz_shuijin_img{
  width: 101px !important;
  height: 125px !important;
  }

  .cz_zhengshu_img{
    width: 240px!important;
    height: 170px!important;
  }
 .cz_zhengshu_table{
   width: 270px !important;
  }

 .cz_chat_img{
   width: 180px!important;
   height: 87px!important;
  }

 .cz_zjt_img{
   width: 90px!important;
   height: 280px!important;
  }

  .cz_hongdian_img tr td img{
    width: 5px!important;
    height: 5px!important;
  }



  .el-row{
    width: auto !important;
  }
}


</style>

